<template>
  <div class="examinationInterface">
      <div class="page-module">

          <AnswerArea :questioninfo="questioninfo" :examstatus="examstatus" :pageinfo="pageinfo" :isshow="isshow" :ischeckover="ischeckover"></AnswerArea>
          <!-- end 答题区 -->

          <div class="position-area">

              <SetupArea ref="setupAre" :examend="examend" :examstatus="examstatus"></SetupArea>
              <!-- end 设置区 -->

              <AnswerCard ref="answerCard" :examend="examend" :examstatus="examstatus" :pageinfo="pageinfo"></AnswerCard>
              <!-- end 答题卡 -->
          </div>
          <!-- end 侧边栏 -->
      </div>

      <ClickContinuePopu ref="clickContinuePopu"></ClickContinuePopu>
      <!-- end 点击继续弹窗 -->

      <SubmitPapersPopu ref="submitPapersPopu"></SubmitPapersPopu>
      <!-- end 提交试卷弹窗 -->

      <PreservationProgressPopu ref="preservationProgressPopu"></PreservationProgressPopu>
      <!-- end 保存进度弹窗 -->

      <ReturnDetailsPopu ref="returnDetailsPopu"></ReturnDetailsPopu>
      <!-- end 返回触发弹窗 -->
  </div>
</template>

<script>
import $ from 'jquery'
import {mapActions} from 'vuex'
import merge from 'webpack-merge'
import SetupArea from './../components/SetupArea.vue'
import AnswerCard from './../components/AnswerCard.vue'
import AnswerArea from './../components/AnswerArea.vue'
import ClickContinuePopu from './../components/popu/ClickContinue.vue'
import ReturnDetailsPopu from './../components/popu/ReturnDetails.vue'
import PreservationProgressPopu from './../components/popu/PreservationProgress.vue'
import SubmitPapersPopu from './../components/popu/SubmitPapers.vue'
import {getQuestionList, saveExamRecord} from 'api/questionbank'
export default {
  name: 'examinationInterface',
  data () {
    return {
      getQuestionListApi: { // 试题列表api
        clienttype: 1,  // pc端
        examid: this.$route.query.examid, // 试卷id 
        page: 1 // 页数
      },
      questioninfo: [], // 试题信息
      examstatus: 0, // 试卷提交状态 1 提交  0 未提交
      examend: {}, // 答题考试用时信息
      pageinfo: {},  // pageCount 最大页数 pageNum 当前页数 pageSize 每页显示条数 rowCount 题目总数
      isshow: 0, // 是否显示正确答案 0 不显示 1显示
      ischeckover: 0, // 是否批阅 0否 1是 为0 展示问答题答案分数--  1则展示分数
      pageStatus: false // 页面状态变化
    }
  },
  mounted () {

    // 是否是只看错题
    this.getQuestionListApi.status = this.$route.query.status === '0' ? 0 : ''

    if (this.$route.query.page) {
      this.getQuestionList(this.$route.query.page)
    } else {
      this.getQuestionList(1)
    }
  
    // innerid 存在时刷新页面可进行锚点跳转
    setTimeout(() => {
        if (this.$route.query.innerid) {
          this.anchorJump(this.$route.query.innerid)
        }
    }, 200)
  },
  methods: {
    getQuestionList(page) { // 获取试题列表
      // 列表跳转初始化为 0 
      $('html').scrollTop(0)
      this.setLoading(true)
      this.getQuestionListApi.page = page

      getQuestionList({ // 获取试卷列表接口
        data: this.getQuestionListApi,
        success: data => {
          this.setLoading(false)

          // 修改当前页路由
          this.$router.push({
            query: merge(this.$route.query, {'page': page})
          })

          // 初始化导航栏名称
          this.$parent.initTestPaperNavTitle(data.data.examname)
          // if (data.data.questioninfo[0].questiontype === 7) {
          //   const obj = {
          //     innerid: "nurR8qeQLmhk5Qmq",
          //     issubmit: 0,
          //     optionslist: [{optionsindex: 1, optionsvalue: "A", optionsinfo: "1"}, {optionsindex: 2, optionsvalue: "B", optionsinfo: "2"}],
          //     quesscore: 10,
          //     questionindex: 1,
          //     questiontype: 1,
          //     questiontypename: "单选题",
          //     subject: "<p>1+1=</p>",
          //     uselanswer: ""
          //   }
          //   data.data.questioninfo[0].questioninfo.push(obj)
          // }
          // 试题信息
          this.questioninfo = data.data.questioninfo
          // 试卷状态
          this.examstatus = data.data.examstatus
          // 答题卡设置
          this.examend = {examendtime: data.data.examendtime, isastrict: data.data.isastrict}
          // 每页显示信息
          this.pageinfo = data.data.pageinfo
          // 是否显示正确答案
          this.isshow = data.data.isshow
          // 是否批阅
          this.ischeckover = data.data.ischeckover

          // 判断是否为页数发生变化 不是则进行锚点跳转
          // 锚点跳转
          // this.$nextTick(() => {
          //   if (this.pageStatus == true) {
          //     console.log('变化')
          //     this.anchorJump(this.$route.query.innerid)
          //   }
          // })
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    setChildExamTime(examTime) {  // 答题卡组件设置考试时间
      if (this.$refs.answerCard) {
        this.$refs.answerCard.setExamTime(examTime)
      }
    },
    startChildClickContinue() { // 点击继续弹窗
      this.$refs.clickContinuePopu.startClickContinue()
    },
    startChildClickContinuePopu() { // 触发返回详情弹窗
      this.$refs.returnDetailsPopu.startPopu()
    },
    startChildPreservationProgressPopu() {  // 触发保存进度弹窗
      this.$refs.preservationProgressPopu.startPopu()
    },
    startChildSubmitPapersPopu() {  // 触发提交试卷弹窗
      this.$refs.submitPapersPopu.startPopu()
    },
    examinationTimeCalculation() {  // 开启设置区域 时间计算器
      if (this.examend.isastrict) {
          this.$refs.setupAre.examinationTimeCalculation()
      }
    },
    anchorJump(innerid) {  // 锚点跳转
      if ($("#"+innerid)[0]) {
        // console.log($("#"+innerid)[0].offsetTop)
        let offsetTop = $("#"+innerid)[0].offsetTop
        // 跳转页面路由
        $('html').scrollTop(offsetTop - 80)
        // console.log($("#"+innerid)[0].offsetTop)
      }
      // console.log($("#"+innerid).scrollTop())
    },
    _combinationExaminationAontent() {
      // 组合考试内容
      // 组合数组
      let answerList = []

      for (let i = 0; i < this.questioninfo.length; i++) {
        let answer = ''
        let questioninfo = []
        switch(parseInt(this.questioninfo[i].questiontype)) { 
          // 1单选题 2多选题 3不定项选择题 4判断题 5填空题 6问答题 7材料题
          case 2:
          case 3:
            for (let j = 0; j < this.questioninfo[i].uselanswer.length; j++) {
              answer += this.questioninfo[i].uselanswer[j] + ','
            }
            // 删除最后一个逗号
            answer = answer.substring(0, answer.lastIndexOf(','))
            break;
          case 5:
            for (let j = 0; j < this.questioninfo[i].uselanswer.length; j++) {
                answer += this.questioninfo[i].uselanswer[j].value + '|'
            }
            answer = answer.substring(0, answer.lastIndexOf('|'))
            break;
          case 7: 
            this.questioninfo[i].questioninfo.forEach((obj) => {
                let item = {
                  "innerid": obj.innerid,
                  "questiontype": obj.questiontype,
                  "uselanswer": ''
                }
                switch(parseInt(obj.questiontype)) {
                  case 1:
                    item.uselanswer = obj.uselanswer
                    break;
                  case 2: 
                  case 3: 
                    for (let j = 0; j < obj.uselanswer.length; j++) {
                      item.uselanswer += obj.uselanswer[j] + ','
                    }
                    // 删除最后一个逗号
                    item.uselanswer = item.uselanswer.substring(0, item.uselanswer.lastIndexOf(','))
                    break;
                  case 5: 
                    for (let j = 0; j < obj.uselanswer.length; j++) {
                        item.uselanswer += obj.uselanswer[j].value + '|'
                    }
                    item.uselanswer = item.uselanswer.substring(0, item.uselanswer.lastIndexOf('|'))
                    break;
                  default: 
                    item.uselanswer = obj.uselanswer
                }
                questioninfo.push(item)
            })
            break;
          default:
            answer = this.questioninfo[i].uselanswer
        }
        if (this.questioninfo[i].questiontype !== 7) {
          // 组合答案数组
          answerList.push({
            "innerid": this.questioninfo[i].innerid,
            "questiontype": this.questioninfo[i].questiontype,
            "uselanswer": answer
          })
        } else {
          answerList.push({
            "innerid": this.questioninfo[i].innerid,
            "questiontype": this.questioninfo[i].questiontype,
            "uselanswer": '',
            "questioninfo": questioninfo
          })
        }
      }
      return answerList
    },
    CallbackSaveExamRecord(answerList, callback) {  // 回调考试纪录接口 answerList 考试答案参数 callback 回调
      this.setLoading(true)
      saveExamRecord({
        data: {questioninfo: JSON.stringify(answerList), exampid: this.$route.query.examid},
        success: data => {
          this.setLoading(false)
          if (data.code == '000') {
            callback()
            // 刷新答题卡
            this.$refs.answerCard.getAnswerSheetInfo()
          } else {
            this.$message.error(data.msg)
          }
        },
        error: data => {
          this.setLoading(false)
          this.$message.error(data.msg)
        }
      })
    },
    ...mapActions(['setLoading'])
  },
  filters: {},
  watch: {
    // 监听路由变化调用接口
    $route: {
      handler(val, oldval) {
        let page = val.query.page,
            oldpage = oldval.query.page,
            innerid = val.query.innerid
            
        
        // 试卷提交情况下 触发
        if (this.examstatus == 1) {
          let status = val.query.status,
              oldStatus = oldval.query.status

        this.getQuestionListApi.status = status
        // if (status !== 0 || status == undefined || status == '') {
          //   this.getQuestionListApi.status = ''
          //   console.log(status)
          // }  else {
          //   this.getQuestionListApi.status = status
          // }
        
          if (status !== oldStatus) {
            this.getQuestionList(page)
            return
          }
        }

        
        // 页面发生变化 调用新的页面
        if (page !== oldpage && oldpage !== undefined) {
          if (page == undefined) {
            this.$router.go(-1)
          } else {
            this.getQuestionList(page)
          }
          
        }
        if (page == oldpage) {
          this.pageStatus = true
        } else {
          this.pageStatus == false
        }
        // 进行锚点跳转
        this.anchorJump(innerid)
      }
    }
  },
  computed: {},
  components: {
    SetupArea,
    AnswerCard,
    AnswerArea,
    ClickContinuePopu,
    ReturnDetailsPopu,
    PreservationProgressPopu,
    SubmitPapersPopu
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.examinationInterface {
  overflow: hidden;
  .answer-area {
    float: left;
    position: relative;
    width: 895px;
  }
  .position-area {
    float: right;
    position: fixed;
    margin: auto;
    left: 0;
    right: -905px;
    width: 265px;
  }
}
</style>